import { ActionsFactory } from "@routes/Article/components/ArticleSubshare/helpers";
import { LambdaResponsePayload } from "@routes/Article/types/Alacrity";

export type ActionsProps = LambdaResponsePayload & {
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function Actions({
  data: { responseType, shortURL, giftCount },
  setIsModalOpen,
}: ActionsProps): React.ReactElement {
  const Actions = ActionsFactory(responseType);

  return (
    <>
      {Actions ? (
        <Actions
          setIsModalOpen={setIsModalOpen}
          link={shortURL}
          giftCount={giftCount}
        />
      ) : null}
    </>
  );
}
